'use strict';

/**
 * @author Maxim Seredkin
 * @param {DaDataRestService} DaDataRestService
 * @param {$q} $q
 * @return {*}
 */
export default ['DaDataRestService', '$q',
                function(DaDataRestService, $q) {
                    return {
                        findByInn: findByInn,
                        api: DaDataRestService,
                    };

                    /**
                     * Получить информацию об организации по ИНН
                     * @param {string} inn
                     * @return {*}
                     */
                    function findByInn(inn) {
                        return $q(function(resolve, reject) {
                            DaDataRestService.findByInn(null, {
                                'query': inn,
                                // 'branch_type': 'MAIN',
                            }, (data) => {
                                resolve(data);
                            });
                        });
                    }
                }];
